import * as Safe from "safe-portals";
import { makeCampaignTargetProviderDef } from "@flow/common/campaign_target_provider";
import { v4 as uuidv4 } from "uuid";

export const multipleFixedTargets = makeCampaignTargetProviderDef({
  provider_unique_id: "basic:multiple_fixed_target",
  label: "Multiple ad-hoc targets",
  config_type: Safe.versioned({
    schema: Safe.array(
      Safe.obj({
        name: Safe.str,
        email: Safe.str,
        guid: Safe.uuid,
      })
    ),
    migrations: [
      (oldConfig) => [oldConfig],
      (oldConfig) =>
        oldConfig.map((c: any) => {
          return { ...c, guid: uuidv4() };
        }),
    ],
  }),
});
